import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Form } from "react-bootstrap";
import { stripe_promise } from "../../constant/commonUtils";
import commonApi from "../../CommonApi/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import { errorMessage, successMessage } from "../../Errors/Toast";
import SpinnerLoader from "../../webLoader/SpinnerLoader";
import { user_profile_info } from "../../Redux/ProfileAction";

const stripePromise = loadStripe(stripe_promise());

// ⬇️ Inner form component
const AddCardForm = ({ handleClose, selecteduser }) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const result = await stripe.confirmSetup({
      elements,
      redirect: "if_required",
    });

    setLoading(false);
    if (result.error) return;

    if (result.error) {
      errorMessage(result.error.message || "Failed to save card.");
    } else {
      successMessage("Card saved successfully!");
      handleClose();
      if (selecteduser) {
        const formdata = new FormData();
        formdata.append("user_id", selecteduser);
        dispatch(user_profile_info(formdata, tokenSelector));
      } else {
        dispatch(user_profile_info("", tokenSelector));
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <PaymentElement />
      <div className="d-flex justify-content-start mt-3">
        <Button
          type="submit"
          variant="primary"
          className="ms-2 submit_button"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </div>
    </Form>
  );
};

// ⬇️ Modal wrapper component
function AddCard({ handleClose, selecteduser, ...props }) {
  const [clientSecret, setClientSecret] = useState("");
  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);

  useEffect(() => {
    commonApi
      .create_setup_intent({}, tokenSelector)
      .then((res) => {
        if (res.success && res.client_secret) {
          setClientSecret(res.client_secret);
        } else {
          errorMessage(res.message || "Failed to create setup intent.");
        }
      })
      .catch((err) => {
        console.error("Setup intent error:", err);
        errorMessage(err.message || "Something went wrong.");
      });
  }, []);

  const options = {
    clientSecret,
    appearance: { theme: "stripe" },
  };

  return (
    <Modal
      id="change_gender"
      className="custom-modal1 custom-modal2 custom-modal3"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <h4>Add Card</h4>
        <i
          className="fa-solid fa-xmark"
          onClick={() => handleClose("Hide")}
        ></i>
      </Modal.Header>

      <Modal.Body>
        {clientSecret ? (
          <Elements stripe={stripePromise} options={options}>
            <AddCardForm
              selecteduser={selecteduser}
              handleClose={handleClose}
            />
          </Elements>
        ) : (
          <div className="d-flex align-items-center justify-content-center">
            <SpinnerLoader color="white" />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AddCard;
